import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { selectSupportOpen, setSupportOpen } from "@/nav/navSlice";
import {
    selectAccountId,
    selectName,
    selectEmail,
    selectSubscription,
    selectOrganizationId,
} from "@/auth/authSlice";

export default function TidioChatController() {
    const dispatch = useDispatch();

    const open = useSelector(selectSupportOpen);
    const accountId = useSelector(selectAccountId);
    const accountName = useSelector(selectName);
    const accountEmail = useSelector(selectEmail);
    const subscription = useSelector(selectSubscription);
    const orgId = useSelector(selectOrganizationId);

    const onScriptLoad = () => {
        window.tidioChatApi.hide();
        window.tidioChatApi.on("close", onClose);

        if (accountId) {
            setAccountData();
        }
    };

    const onClose = () => {
        dispatch(setSupportOpen(false));
    };

    const setAccountData = () => {
        window.tidioChatApi.setVisitorData({
            distinct_id: accountId,
            name: accountName,
            email: accountEmail,
            tags: [`sub: ${subscription}`, `org: ${orgId}`],
        });
    };

    useEffect(() => {
        if (!window.tidioChatApi) {
            return;
        }
        if (open) {
            window.tidioChatApi.show();
            window.tidioChatApi.open();
        } else {
            window.tidioChatApi.hide();
        }
    }, [open]);

    useEffect(() => {
        if (!window.tidioChatApi) {
            return;
        }
        if (accountId) {
            setAccountData();
        }
    }, [accountId]);

    useEffect(() => {
        if (window.tidioChatApi) {
            window.tidioChatApi.on("ready", onScriptLoad);
        } else {
            document.addEventListener("tidioChat-ready", onScriptLoad);
        }
    }, []);

    return null; // no visible UI in this component
}
